import * as React from 'react';
import { assign as _assign } from 'lodash';
import { connect } from 'react-redux';
import { requestAPIActions, QueryFilterParams } from 'loopback-react-request';
import { GlobalPrivateState, QueryParemeterPayload, } from '../../../api';
import { isConfigurationEditable } from 'src/redux/utils.redux';

export interface TroughsDispatcherProps {
  configuration: GlobalPrivateState['configuration'];
  dispatch: any;
  queryState: GlobalPrivateState['queryState'];
}

const dispatchKey = 'troughs';

class TroughsDispatcherContainer extends React.Component<TroughsDispatcherProps> {

  componentDidMount() {
    this.dispatchTroughs();
  }

  componentDidUpdate(prevProps: TroughsDispatcherProps) {
    const search = this.props.queryState.search;
    const prevSearch = prevProps.queryState.search;
    if (search !== prevSearch) {
      this.dispatchTroughs();
    }
  }

  public render() {
    return null;
  }

  private get sword(): QueryParemeterPayload['sword'] | undefined {
    return this.props.queryState && this.props.queryState.params && this.props.queryState.params.sword;
  }

  private get filter(): QueryParemeterPayload['filter'] | undefined {
    return this.props.queryState && this.props.queryState.params && this.props.queryState.params.filter;
  }

  private get swordParams(): QueryFilterParams {
    const sword = this.sword;
    let where: QueryFilterParams['where'] = {};
    if (sword) {
      where = _assign({}, {'name': {'like': `${sword}`, 'options': 'i'}});
    }
    return where;
  }

  private get artParams(): QueryFilterParams {
    const filter = this.filter;
    let where: QueryFilterParams['where'] = {};
    if (filter && filter.art) {
      const art = filter.art.toLowerCase();
      where = _assign({}, {[art]: true});
    }
    return where;
  }

  private get overflowParams(): QueryFilterParams {
    const filter = this.filter;
    let where: QueryFilterParams['where'] = {};
    if (filter && filter.overflow) {
      let overflow = filter.overflow;
      where = _assign({}, {[overflow]: true});
    }
    return where;
  }

  private get backWallParams(): QueryFilterParams {
    const filter = this.filter;
    let where: QueryFilterParams['where'] = {};
    if (filter && filter.backwall) {
      let backwall = filter.backwall;
      where = _assign({}, {[backwall]: true});
    }
    return where;
  }

  private get formParams(): {[key: string]: boolean}[] {
    const filter = this.filter;
    const or: {[key: string]: boolean}[] = [];
    if (filter && filter.form && filter.form.length > 0) {
      filter.form.map(param => or.push({[param]: true}));
    }
    return or;
  }

  private get queryParams(): any {    
    const and: (QueryFilterParams | {or: {[key: string]: boolean}[]})[] = [];
    if (this.swordParams && Object.keys(this.swordParams).length > 0) {
      and.push(this.swordParams);
    }
    if (this.artParams && Object.keys(this.artParams).length > 0) {
      and.push(this.artParams);
    }
    if (this.overflowParams && Object.keys(this.overflowParams).length > 0) {
      and.push(this.overflowParams);
    }
    if (this.backWallParams && Object.keys(this.backWallParams).length > 0) {
      and.push(this.backWallParams);
    }
    const formParams = this.formParams;
    if (formParams && formParams.length > 0) {
      if (and.length > 0) {
        and.push({or: formParams});
      } else {
        return {or: formParams};
      }
    }
    return and && and.length > 0 ? {and: and} : {};
  }

  private dispatchTroughs() {
    // if (!isConfigurationEditable()) { return; }
    
    const queryParams = _assign({}, {
      where: this.queryParams,
      order: 'name'
    });
    
    this.props.dispatch(requestAPIActions.load(
      dispatchKey, {
        url: `/Troughs?filter=${encodeURIComponent(JSON.stringify(queryParams))}`,
      }
    ));
  }
}

export const TroughsDispatcher = connect((state: GlobalPrivateState) => ({
  userData: state.userData,
  configuration: state.configuration,
  queryState: state.queryState,
}))(TroughsDispatcherContainer);
